<wl-card heading="Geo Mapping Report">
  <form novalidate [formGroup]="geoMappingForm" *ngIf="disablesatsureform">
    <wl-input type="text" label="Farmer Name" placeholder=" Enter Name" formControlName="farmerName"></wl-input>

    <div class="container">
      <div class="row">

        <div class="col-md-5,col-lg-4">
          <mat-select *ngIf="showList" class="ml-30vw max-w-auto w-32vw"
            placeholder="Choose a Crop" formControlName="cropName">
            <mat-option *ngFor="let crop of crops" [value]="crop.name">{{crop.name}}</mat-option>
          </mat-select>

        </div>
      </div>
    </div>

    <wl-input type="text" label="Co-ordinates" placeholder=" Enter Co-ordinates" formControlName="coordinates">
    </wl-input>
    <wl-button (click)='openDialog()'>Select Co-ordinates</wl-button>
    <br>

    <mat-progress-bar color="primary" mode="query" value="50" *ngIf="isLoading"></mat-progress-bar>

    <wl-button [disabled]="!geoMappingForm.valid" (click)="submitForm()">Submit</wl-button>
    <br>
    <span class="text-B60A0A ml-1vw">NOTE: The report will be available after 2 hours of submitting the request. </span>
  </form>

  <span *ngFor="let file of geodata; let i=index">
    <div class="col-12 text-center-important"> 

        <button (click)="downloadPdf(i)" class="h-40px mybutton"
        target="_blank">Download
        Report - {{i+1}}</button>
   </div><br>
  </span>


  <table>
    <tr>
      <td  class="w-30vw"></td>
      <td class="text-center">
        <div *ngIf="showReport" class="col-12 text-center-important ml-2vw text-white">
          <a href="{{s3Url}}{{docPath}}" class="h-18px mybutton" target="_blank">View Document</a>
        </div>
      </td>
      <td></td>
    </tr>
  </table>
  <br>

</wl-card>